import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '../store/authStore';

/**
 * Punto de entrada '/'. Decide destino según sesión y rol:
 *   sin sesión                         -> /login
 *   superadmin/facilitador/decisor     -> /procesos (portada del conductor)
 *   resto (participante)               -> /app (Bolsillo)
 */
export function RootRedirect() {
  const status = useAuthStore((s) => s.status);
  const user = useAuthStore((s) => s.user);
  const hydrate = useAuthStore((s) => s.hydrate);

  useEffect(() => {
    if (status === 'idle') void hydrate();
  }, [status, hydrate]);

  if (status === 'idle' || status === 'hydrating') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface-base">
        <Loader2 className="h-5 w-5 animate-spin text-content-muted" aria-hidden="true" />
      </div>
    );
  }

  if (status === 'anonymous' || !user) {
    return <Navigate to="/login" replace />;
  }

  const conduce =
    user.rol === 'superadmin' ||
    user.rol === 'admin_org' ||
    user.rol === 'facilitador' ||
    user.rol === 'decisor';
  return <Navigate to={conduce ? '/procesos' : '/app'} replace />;
}
